<lib-sticky-modal>
  <lib-sticky-header>
    <app-collection-displays-modal-header [title]="modalTitle$ | async" [showClearButton]="false">
    </app-collection-displays-modal-header>
  </lib-sticky-header>
  <lib-sticky-body [placeInSameZPlaneAsHeaderAndFooter]="true">
    <div class="edit-collection-create-new-display-container">
      <div class="mb-24px mt-16px bs-bold f14px">Display Info</div>
      <lib-reactive-form-group
        #newDisplayDetails
        [bindTo]="container.pendingDisplay$ | async"
        (formSubmitted$)="container.connectToPendingDisplay($event); container.incrementEditStep()">
        <lib-reactive-form-text
          [label]="'Display Name'"
          [inputName]="'displayName'"
          [placeholder]="'Enter the display name'"
          [required]="true"
          [bindingProperty]="'pendingDisplay.name'"></lib-reactive-form-text>

        <lib-reactive-form-searchable-drop-down
          [label]="'Display Size'"
          [inputName]="'displaySize'"
          [placeholder]="'Select the size of this display'"
          [sortDropdownListBy]="null"
          [dropdowns]="container.displaySizeOptions$ | async"
          [required]="true"
          [programmaticallyChangeValue]="container.displaySize$ | async"
          [bindingProperty]="'pendingDisplay.displaySize.name'">
        </lib-reactive-form-searchable-drop-down>

        <lib-reactive-form-searchable-drop-down
          [label]="'Orientation'"
          [tooltip]="'Portrait is a 90º clockwise rotation. Reverse portrait is a 90º counterclockwise rotation.'"
          [inputName]="'orientation'"
          [placeholder]="'Select the orientation of this display'"
          [dropdowns]="container.orientationOptions$ | async"
          [required]="true"
          [programmaticallyChangeValue]="container.orientation$ | async"
          [bindingProperty]="'pendingDisplay.displaySize.orientation'">
        </lib-reactive-form-searchable-drop-down>
      </lib-reactive-form-group>
    </div>
  </lib-sticky-body>
  <lib-sticky-footer>
    <app-go-back-modal-footer
      [includeStickyFooterContainerClass]="false"
      [showPrimaryButton]="true"
      [primaryButtonText]="'Next'"
      [showBackButton]="container.startingAtStepZero$ | async"
      [disablePrimaryButton]="newDisplayDetails.hasErrors$ | async"
      (goBack)="container.goBack()"
      (primaryButtonClicked)="newDisplayDetails.submitForm(false)"
      (cancelClicked)="cancelClicked.emit()">
    </app-go-back-modal-footer>
  </lib-sticky-footer>
</lib-sticky-modal>
